// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__25YxV","dragIcon":"Choice_dragIcon__3zckh","left":"Choice_left__2BdU2","input":"Choice_input__ud4XH"};